import type { IMasterDataRetailerMatchRuleRepository } from "@src/domain/repositories/masterData";

export class GetMasterDataRetailerMatchSourceColumnsUseCase {
  private readonly repository: IMasterDataRetailerMatchRuleRepository;

  constructor(repository: IMasterDataRetailerMatchRuleRepository) {
    this.repository = repository;
  }

  execute(): Promise<string[]> {
    return this.repository.getMatchSourceColumns();
  }
}
